import React, { useEffect, useRef } from "react";
import "../Css/WhyChooseUs.css";
import maidImg from "../assets/maid1.png";

const WhyChooseUs = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("active");
        }
      },
      { threshold: 0.25 } // triggers when 25% visible
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="why-choose" ref={sectionRef}>
      <div className="why-container">

        <div className="why-left">
          <span className="why-tag">WHY CHOOSE US</span>
          <h2>Why Choose Tanya Maid Service?</h2>

          {/* Mobile image */}
          <div className="why-image-mobile">
            <img src={maidImg} alt="Professional Maid" />
          </div>

          <div className="why-item">
  <div className="hexagon blue">01</div>
  <div className="why-text">
    <h4>Professional Maids</h4>
    <p>Skilled and experienced in cleaning, cooking, laundry, and childcare.</p>
  </div>
</div>

<div className="why-item">
  <div className="hexagon red">02</div>
  <div className="why-text">
    <h4>Verified & Reliable</h4>
    <p>Strict background checks ensure safety and trust.</p>
  </div>
</div>

<div className="why-item">
  <div className="hexagon green">03</div>
  <div className="why-text">
    <h4>Flexible Services</h4>
    <p>Full-time, part-time, or hourly help based on needs.</p>
  </div>
</div>

<div className="why-item">
  <div className="hexagon blue">04</div>
  <div className="why-text">
    <h4>Top Maid Agency in Mumbai</h4>
    <p>Trusted for high-quality domestic help.</p>
  </div>
</div>

<div className="why-item">
  <div className="hexagon cyan">05</div>
  <div className="why-text">
    <h4>Personalized Matching</h4>
    <p>Maids assigned as per your preferences.</p>
  </div>
</div>

<div className="why-item">
  <div className="hexagon blue">06</div>
  <div className="why-text">
    <h4>Efficient Support</h4>
    <p>Dedicated support team always available.</p>
  </div>
</div>

        </div>

        <div className="why-right">
          <img src={maidImg} alt="Professional Maid" />
        </div>

      </div>

      <p className="why-bottom-text">
        If you want to hire reliable maid in Mumbai, Tanya Maid Service offers a seamless
        process to find the right domestic helper for your home.
      </p>
    </section>
  );
};

export default WhyChooseUs;
